export class mdlGetMobilenoVerificationRes {
    referenceNumber: string;
    id: string;
    mobile: string;
    isOwner: boolean;
    StatusCode: string;
    StatusDesc: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlGetMobilenoVerificationRes.ts